import React from 'react';
import { createUseStyles } from 'react-jss';

import { Theme } from '@app/theme';
import { DurationChip, IncentiveChip } from '@app/core';
import { Participation } from '@app/api';
import classnames from 'classnames';
import { ParticipationStatusChip } from './ParticipationStatusChip';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.marginBase,
  },
  hide: {
    [theme.media.mobile]: {
      display: 'none',
    },
  },
}));

interface Props {
  participation: Participation;
}

export const TagsConfirmedParticipationHeader = ({ participation }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classnames(classes.container, classes.hide)}>
        <ParticipationStatusChip status={participation.status} />
        <IncentiveChip participation={participation} color="inkSecondary" />
        <DurationChip participation={participation} color="inkSecondary" />
      </div>
    </div>
  );
};
